<template>
    <div class="nx-searcher-filter-select-wrapper px-4">
        <v-autocomplete
            :items="items"
            :value="multipleValue"
            :placeholder="$t(`message.searcher.filters.${filter}`)"
            @input="updateFilter"
            :multiple="multiple"
            :disabled="disabled"
            chips
            deletable-chips
            clearable
            :menu-props="setMenuProps"
            :value-comparator="(a,b) => a == b"
            :filter="normalizeFilter"
        >
        </v-autocomplete>
    </div>
</template>

<script>
import { isObject } from 'lodash';
import normalizeText from '@/plugins/normalize-text';
import Filter from '@/components/filters/components/Filter';
import MultiValueFilter from '@/components/filters/mixins/MultiValueFilter';

export default {
  name: 'nx-searcher-filter-select',
  extends: Filter,
  mixins: [MultiValueFilter],
  props: {
    options: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    attach: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    normalizeFilter(item, queryText, itemText) {
      if (queryText === null || queryText.length === 0) {
        return true;
      }
      return (
        itemText
        && itemText.length > 0
        && normalizeText(item.text).includes(normalizeText(queryText))
      );
    },
  },
  computed: {
    items() {
      return this.options.map((option) => {
        if (isObject(option)) {
          const { value, text } = option;
          return { value, text };
        }
        return {
          value: option,
          text: this.$t(`message.searcher.filters.values.${this.filter}.${option}`),
        };
      });
    },
    setMenuProps() {
      return {
        closeOnClick: false,
        closeOnContentClick: false,
        openOnClick: false,
        maxHeight: 300,
        offsetY: true,
        offsetOverflow: false,
        transition: false,
      };
    },
  },
};
</script>
